import { css } from '@emotion/css'

import { fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'center',
    borderBottom: `dashed 1px ${colors.mystic}`,
    paddingBottom: spacing.default,
    marginBottom: spacing.default,

    ':last-of-type': {
      marginBottom: spacing.medium,
    },
  }),

  roleData: css({
    flex: '0 1 100%',

    p: {
      margin: 0,
      fontWeight: fontWeight.medium,
      marginBottom: spacing.small,
    },

    'p:first-child': {
      color: colors.blackPearl,
    },

    'p:last-child': {
      color: colors.scorpion,
      fontWeight: fontWeight.regular,
    },
  }),

  deleteButton: css({
    marginRight: spacing.small,
  }),
}

export default styles
